<template>
    <div class="ma-4">
        <!--<v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>-->
        <v-data-table
            :page="page"
            :pageCount="pageCount"
            :server-items-length="itemCount"
            :options.sync="options"
            :headers="headers"
            :items="notificationsAll"
            sort-by="Name"
            sort-desc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Notifications"
        >
            <template v-slot:top>
                <div>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Notifications</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-btn color="#2b3990" dark class="mb-2" @click="markNotificationAsRead()">
                            MARK AS READ
                        </v-btn>
                        <v-btn v-if="userRole === 'Administration'" color="#2b3990" dark class="mb-2 ml-2" @click="showDeleteDialog = true">
                            Delete Notifications
                        </v-btn>
                    </v-toolbar>

                    <v-dialog v-model="showDeleteDialog" max-width="600px">
                        <v-card>
                            <v-card-title>Delete Notifications</v-card-title>
                            <v-card-text>
                                <v-form>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-card-title>From</v-card-title>
                                            <v-date-picker v-model="startDate" label="Start Date"></v-date-picker>
                                        </v-col>
                                        <v-col cols="6">
                                             <v-card-title>To</v-card-title>
                                            <v-date-picker v-model="endDate" label="End Date"></v-date-picker>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="grey" text @click="showDeleteDialog = false">Cancel</v-btn>
                                <v-btn color="error" text @click="deleteNotifications">Delete</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
                <v-toolbar flat color="white">
                    <v-col cols="12" sm="12" md="4">
                        <v-select
                            label="Program"
                            v-model="newProgram"
                            :items="units"
                            item-text="Name"
                            item-value="Name"
                        ></v-select>
                    </v-col>
                    <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                        <v-btn x-small @click="searchUserNotificationByProgram()">Search</v-btn>
                    </v-flex>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn icon>
                    <v-icon title="Mark as Read" v-if="!item.readerUserIds.includes(userID)" small
                            @click="readNotification(item)">
                        mdi-bell-remove-outline
                    </v-icon>
                    <v-icon title="Notification Already Read" v-if="item.readerUserIds.includes(userID)" small
                            color="green">
                        mdi-checkbox-marked-circle
                    </v-icon>
                </v-btn>
            </template>
            <template v-slot:item.checkbox="{item}">
                <v-checkbox @click="selectNotification(item._id)" :input-value="isSelectedNotification(item._id)">
                </v-checkbox>
            </template>
        </v-data-table>
        <Foot/>
    </div>
</template>

<!--
<template>
  <div class="ma-4">
    <v-list disabled>
      <v-subheader>NOTIFICATIONS</v-subheader>
      <v-list-item-group v-model="item" color="primary">
        <v-list-item v-for="(item, index) in notificationsAll" :key="index">
          <v-list-item-main>
            <v-list-item-title v-text="item.Title"></v-list-item-title>
            <v-list-item-subtitle v-html="item.Description"></v-list-item-subtitle>
          </v-list-item-main>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>
-->
<script>
    import axios from 'axios'
    import moment from 'moment';
    import Foot from '../components/Footer'
    import DateTimeUtil from '../../utils/date-time.util';
    import NotificationService from '../service/notification.service';
    import Swal from 'sweetalert2'


    const url = require("../client_config/config").url;


    export default {
        components: {
            Foot,
        },
        data: function () {
            return {
                notificationsAll: [],
                users: [],
                clients: [],
                selectedNotificationIds: [],
                userID: localStorage.getItem('userID'),
                item: '',
                headers: [
                    {text: "", value: "checkbox", sortable: false},
                    {text: "User", value: "createdBy.Name"},
                    {text: "Title", value: "title"},
                    {text: "Description", value: "description"},
                    {text: "Date Created", value: "createdAt"},
                    {text: "Status", value: "actions", sortable: false},
                ],
                isLoading: true,
                page: 1,
                pageCount: 1,
                itemCount: 0,
                options: {},
                newProgram: "",
                units: [],
                clientIds: [],
                clientIdsWithinSelectedUnit: [],
                showDeleteDialog: false,
                startDate: null,
                endDate: null,
                dateRange: null,
                userRole: localStorage.getItem('userRole'),
            };
        },
        computed: {},

        watch: {
            options: {
                handler() {
                    this.getAllNotifications();
                },
                deep: true
            }
        },

        created() {
            this.getAllNotifications();
            this.getUnits();
        },

        methods: {
            initialize() {
                this.notificationsAll = [];
            },
            getAllNotifications() {
                this.isLoading = true;
                let {page, itemsPerPage} = this.options;
                page = page || 1;
                itemsPerPage = itemsPerPage || 10;

                const params = {
                    page: page,
                    limit: itemsPerPage
                };

                NotificationService.getAuthUserNotifications(params)
                    .then(response => {
                        const {docs, totalPages, totalDocs} = response.data;
                        this.notificationsAll = docs.map(notification => {
                            notification.createdAt = DateTimeUtil.toLocalDateTime(notification.createdAt);
                            return notification;
                        });
                        this.pageCount = totalPages;
                        this.itemCount = totalDocs;
                    })
                    .finally(() => {
                        this.isLoading = false
                    });
            },

            readNotification(notification) {
                const payload = {
                    notificationIds: [notification._id]
                };
                NotificationService.readAuthUserNotifications(payload)
                    .then((response) => {
                        alert(response.data.success);
                        notification.readerUserIds.push(this.userID);
                    });
            },
            selectNotification(notificationId) {
                const index = this.selectedNotificationIds.indexOf(notificationId);
                if (index > -1) {
                    this.selectedNotificationIds.splice(index, 1);
                } else {
                    this.selectedNotificationIds.push(notificationId);
                }
            },
            isSelectedNotification(notificationId) {
                let item = "";
                const index = this.selectedNotificationIds.indexOf(notificationId);
                if (index > -1) {
                    item = this.selectedNotificationIds[index];
                }
                return item;
            },
            markNotificationAsRead() {
                if (this.selectedNotificationIds.length < 1) {
                    alert('Please select notification(s) to be marked as read.');
                    return;
                }

                const payload = {
                    notificationIds: this.selectedNotificationIds
                };
                NotificationService.readAuthUserNotifications(payload)
                    .then((response) => {
                        alert(response.data.success);
                        this.selectedNotificationIds.forEach(notificationId => {
                            const index = this.notificationsAll.findIndex(notification => notification._id === notificationId);

                            if (index > -1) {
                                this.notificationsAll[index].readerUserIds.push(this.userID);
                            }
                        });

                        this.selectedNotificationIds = [];
                    });
            },
            // getNotifByUserId(){
            //   this.getUsers(this.userID)
            // },
            // getNotificationByStaffId(id) {
            //   axios.get(`${url}/notifications/staff/${id}`).then((res) => {
            //     this.notificationsAll = res.data.notifications;
            //   });
            // },
            // getUsers(id) {
            //   axios.get(`${url}/users/${id}`).then((res) => {
            //     this.users = res.data.user;
            //     if(this.users.Role === 'Administration'){
            //       this.getAllNotifications();
            //     }else{
            //       this.getNotificationByStaffId(id);
            //     }
            //   });
            // },
            getUnits: function () {
                axios.get(`${url}/units`).then(async res => {
                    res.data.units.forEach(item => {
                        this.units.push(item.Name)
                    })
                });
            },
            // searchUserNotificationByProgram() {
            //   axios.get(`${url}/notifications/search?program=${this.newProgram}`).then((response) => {
            //     this.notificationsAll = response.data.notifications;
            //   });
            // },

            searchUserNotificationByProgram() {
                this.isLoading = true;
                let {page, itemsPerPage} = this.options;
                page = page || 1;
                itemsPerPage = itemsPerPage || 10;

                axios.get(`${url}/notifications/search/${this.newProgram}?page=${page}&limit=${itemsPerPage}`)
                    .then(response => {
                        const {docs, totalPages, totalDocs} = response.data;

                        this.notificationsAll = docs.map((notification) => {
                            let dt = new Date(notification.CreatedDate);
                            notification.CreatedDate = moment(dt).format("MMM D YYYY hh:mm a");

                            return notification;
                        });
                        this.pageCount = totalPages;
                        this.itemCount = totalDocs;
                    })
                    .finally(() => {
                        this.isLoading = false
                    });
            },

            deleteNotifications() {
                if (confirm("Are you sure you want to delete these notifications?")) {
                    const isoStartDate = new Date(this.startDate).toISOString();
                    const isoEndDate = new Date(this.endDate).toISOString();

                    Swal.fire({
                        title: 'Please wait',
                        text: 'Deleting notifications...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading()
                        }
                    });

                    axios.delete(`${url}/notifications/delete`, {
                        data: {
                            isoStartDate,
                            isoEndDate
                        }
                    })
                        .then(response => {
                            console.log(response.data.message);
                            Swal.close();

                            Swal.fire({
                                title: 'Success!',
                                text: response.data.message,
                                icon: 'success'
                            }).then(() => {
                                location.reload();
                            });
                        })
                        .catch(error => {
                            console.error(error);
                            Swal.close();

                            Swal.fire({
                                title: 'Error!',
                                text: 'An error occurred while deleting notifications.',
                                icon: 'error'
                            });
                        });
                }

                this.showDeleteDialog = false;
            }

        },
    };

</script>
